<template>
  <v-container
    id="itemsSearchList"
    fluid
    tag="section"
    class="full-height"
  >
    <base-v-component
      heading="Търсене на артикули"
    />
    
    <filter-items-search
      ref="itemsSearchFilter"
      @doFilter="getData"
    />

    <base-material-card
      hover-reveal
      color="primary"
      icon="mdi-clipboard-text-search-outline"
      inline
      class="px-5 py-5 mt-15"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light"></div>
      </template>

      <v-divider class="mt-3 mb-6" />
      
      <base-data-table 
        :headers="table.headers" 
        :pagination="table.pagination" 
        :data="table.data" 
        :sortBy.sync="table.sortBy"
        :sortDesc.sync="table.sortDesc" 
        @getData="getData" 
        @doAction="doAction"
      />
    </base-material-card>
  </v-container>
</template>

<script>
import { filterItemsSearch } from "@/components";
import { getSearchItems } from '@/api/items';

export default {
  name: 'inventoriesList',
  components: {
    filterItemsSearch,
  },
  data: () => ({
    table: {
      headers: [
        { text: 'Дата', value: 'date', valueType: "date" },
        { text: 'Наименование', value: 'name', valueType: "text" },
        { text: 'Автор', value: 'author', valueType: "text" },
        { text: 'Инв. №', value: 'inventoryNumber', valueType: "text" },
        { text: 'Сигнатура', value: 'signature', valueType: "text" },
        { text: 'Година', value: 'publishedYear', valueType: "text" },
        { text: 'RFID запис', align: 'center', value: 'isWritten', valueType: "status", active: 1, notActive: 0, statusIcons: true, activeClass: 'fw600 success--text text-center', notActiveClass: 'fw600 error--text text-center' },
        {
          sortable: false,
          text: '',
          value: '',
          valueType: 'button',
          style: "width: 50px;",
          class: 'text-right px-0 pr-2',
          buttons: [
            {
              label: 'Преглед',
              title: 'Преглед',
              icon: 'mdi-text-box-search-outline',
              size: 'small',
              class: 'primary ml-1',
              click: 'previewItem',
            }
          ]
        },
      ],
      data: [],
      pagination: {
        itemsPerPage: 10,
        page: 1,
        perPageOptions: [5, 10, 25, 50, 100],
        total: 0
      },
      sortBy: 'date',
      sortDesc: true,
    }
  }),
  mounted(){
  },
  methods: {
    getData(){
      let query = Object.assign({}, this.$refs.itemsSearchFilter.filters);
      if(!query.page) query.page = this.table.pagination.page;
      query.itemsPerPage = this.table.pagination.itemsPerPage;
      query.sortBy = this.table.sortBy;
      query.sortDesc = this.table.sortDesc;
      getSearchItems(query).then(data => {
        this.table.data = data.Items;
        this.table.pagination.total = data.Total;
        this.table.pagination.page = query.page;
      })
    },
    doAction(actionData) {
      switch(actionData.action){
        case 'previewItem':
          this.$router.push({path: `/items/${actionData.item._id}`})
        break;
      }
    }
  }
}
</script>
